export const appNames = {
  ETH: 'Ethereum',
  ETC: 'Ethereum Classic',
  GO: 'GoChain',
  XDC: 'XDC Network',
  Rootstock: 'RSK',
  'Eth Recovery': 'Eth Recovery'
};
